import {routes} from "../../app/constants/routes";

import {renderModalError} from "../../../utils/forms";

export const renderLicenseeModalError = () => {
    return renderModalError('Licensee', routes.licensees.index.path)
};
renderModalError.displayName = 'renderLicenseeModalError';
